import React, { FC } from 'react'
import { PayItForwardIcon } from '@/atoms/Icons/PayItForwardIcon'
import { Image } from '@/atoms/Image'
import { InternalLink } from '@/atoms/InternalLink'
import { AsLabel, CaptionMD, CaptionSM } from '@/atoms/Text'
import { Project } from '@/services/ProjectsService'
import { getLogoTransformation } from '@/utils/Cloudinary'
import { useSafeTrack } from '@/utils/analytics'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

interface PIFPosterButtonlessVariantProps {
  project: Project
}

export const PIFPoster: FC<PIFPosterButtonlessVariantProps> = ({ project }) => {
  const { t } = useTranslate('pif')
  const { discoveryPosterTransformation, discoveryPosterCloudinaryPath, name, logoCloudinaryPath, slug, title } =
    project

  const track = useSafeTrack()

  const handlePIFClick = () => {
    track('Get Started PIF Link Clicked', {
      projectSlug: project.slug,
    })
  }

  const logoTransformation = getLogoTransformation({ logoCloudinaryPath })
  const src = title?.portraitAngelImage?.cloudinaryPath
    ? `/${title.portraitAngelImage.cloudinaryPath}.webp`
    : `c_crop,ar_0.6/${logoTransformation}${discoveryPosterTransformation}/${discoveryPosterCloudinaryPath}.webp`

  return (
    <div className="group rounded-2xl bg-core-gray-950 p-2 transition ease-in-out hover:bg-core-gray-900">
      <InternalLink onClick={handlePIFClick} key={slug} href={`/pay-it-forward/${slug}`}>
        <Image
          aria-label={name}
          alt={name}
          className="rounded-lg border border-solid"
          height={490}
          loading="lazy"
          src={src}
          style={{ width: '100%', height: 'auto' }}
          width={294}
        />
        <div className="mt-3 flex w-full items-center justify-center gap-1.5 py-2 md:mt-4 md:gap-2.5 md:py-3">
          <PayItForwardIcon className="md:hidden" color="white" size={16} />
          <PayItForwardIcon className="hidden md:block" color="white" size={20} />
          <CaptionSM className="whitespace-nowrap group-hover:cursor-pointer md:hidden" weight="semibold" as={AsLabel}>
            <Translate t={t} i18nKey="payItForward">
              Pay it Forward
            </Translate>
          </CaptionSM>
          <CaptionMD
            className="hidden whitespace-nowrap group-hover:cursor-pointer md:block"
            weight="semibold"
            as={AsLabel}
          >
            <Translate t={t} i18nKey="payItForward">
              Pay it Forward
            </Translate>
          </CaptionMD>
        </div>
      </InternalLink>
    </div>
  )
}
